import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackEvent, WEB_NAV_CLICK } from '../../lib/analytics';
import styles from './Nav.module.css';
import { DownloadFreeButton } from '../shared/DownloadFreeButton';
import { MobileNavOverlay } from './MobileNavOverlay';
import logo from '../../assets/images/logo.png';

const links = [
  { id: 'home', label: 'Home', href: '/' },
  { id: 'quiz', label: 'Quiz', href: '/quiz' },
  { id: 'blog', label: 'Blog', href: '/blog' },
  { id: 'about', label: 'About', href: '/about' },
  { id: 'partners', label: 'Partner login', href: '/partners/login' },
];

function trackNavClick(destination: string) {
  void trackEvent(WEB_NAV_CLICK, { destination });
}

export function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <nav className={styles.nav}>
        <div className={styles.inner}>
          <Link to="/" className={styles.logo} aria-label="LuvLust home" onClick={() => trackNavClick('/')}>
            <img src={logo} alt="" width={36} height={36} />
            <span className={styles.wordmark}>LuvLust</span>
          </Link>

          <div className={styles.desktopLinks}>
            {links.map((l) => (
              <Link
                key={l.id}
                to={l.href}
                className={`${styles.navLink} ${location.pathname === l.href ? styles.active : ''}`}
                onClick={() => trackNavClick(l.href)}
              >
                {l.label}
              </Link>
            ))}
          </div>

          <div className={styles.desktopCta}>
            <DownloadFreeButton />
          </div>

          <button
            className={styles.hamburger}
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <svg width="26" height="18" viewBox="0 0 26 18" fill="none">
              <rect width="26" height="2" rx="1" fill="white" />
              <rect y="8" width="26" height="2" rx="1" fill="white" />
              <rect y="16" width="26" height="2" rx="1" fill="white" />
            </svg>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <MobileNavOverlay
          links={links}
          onClose={() => setMenuOpen(false)}
          onNavClick={trackNavClick}
        />
      )}
    </>
  );
}
